import { BaseModernLayouter } from './BaseModernLayouter';
import { LayoutData, SpacingMode } from '../LayoutData';
import { UpVectorMode, AlignmentMode } from '../../field/FieldTypes';
import { POI } from '../../poi/POI';
import { Vector3 } from '../../types/Vector3';

// Import our modern layouters (JS files)
declare const ModernLayouters: any;

export class ModernLineLayouter extends BaseModernLayouter {
    constructor() {
        super(
            'modern-line', 
            'Modern Line Layouter with TestField Logic',
            {
                modernLineFixedSpacing: 3.0,
                modernFlip180: false
            },
            '1d',
            [SpacingMode.Fixed]
        );
    }

    // ========================================
    // IMPLEMENTATION OF ABSTRACT METHODS
    // ========================================

    protected getModernLayouterFunction(): (config: any) => any[] {
        return ModernLayouters.line;
    }

    protected createConfig(pois: POI[], layoutData: LayoutData): any {
        const lineDirection = layoutData.lineDirection?.value || new Vector3(0, 0, 1);
        return {
            objectCount: pois.length,
            spacingMode: this.getSpacingModeString(layoutData),
            spacing: this.getParameter(layoutData, 'modernLineFixedSpacing', 3.0),
            pathType: 'line',
            orientation: layoutData.alignmentMode?.value === AlignmentMode.Aligned ? 'aligned' : 'perpendicular',
            upMode: layoutData.upVectorMode?.value === UpVectorMode.WorldUp ? 'world' : 'path',
            flip180: this.getFlipParameter(layoutData),
            lineDirection: { x: lineDirection.x, y: lineDirection.y, z: lineDirection.z },
            time: 0
        };
    }

    protected getLayouterName(): string {
        return 'ModernLineLayouter';
    }

    validateParameters(layoutData: LayoutData): boolean {
        const spacing = this.getParameter(layoutData, 'modernLineFixedSpacing', 3.0);
        return spacing > 0;
    }


}